// Attributs et index Meilisearch de la recherche d'œuvres, partagés par la
// recherche, ses URL et la conversion des alertes.

/**
 * Actual Meilisearch attribute for sub-universes.
 * Do NOT use SearchEngineFilters.SousUnivers which equals 'sous_univers' (incorrect).
 * The UniverseFilter widget uses 'univers.sous_univers_id.id'.
 */
export const SUB_UNIVERSE_ATTRIBUTE = 'univers.sous_univers_id.id';

/** Meilisearch index name for the books collection. */
export const MEILISEARCH_INDEX_NAME = 'livres';

/** Index Meilisearch des œuvres vu par un admin (brouillons et vendues). */
export const MEILISEARCH_PRIVATE_INDEX_NAME = 'livres_private';

export type BooksIndexName =
  | typeof MEILISEARCH_INDEX_NAME
  | typeof MEILISEARCH_PRIVATE_INDEX_NAME;

/** Index que /recherche ouvre pour ce lecteur : y lier directement évite sa redirection. */
export function getBooksIndexName(isAdmin: boolean): BooksIndexName {
  return isAdmin ? MEILISEARCH_PRIVATE_INDEX_NAME : MEILISEARCH_INDEX_NAME;
}
